module.exports = __webpack_public_path__ + "img/779bacb.svg";